export default __webpack_public_path__ + "static/media/aman.702f4ba7.svg";